import type { Styles } from '@adornis/ass/style.js';
import { Size } from '@adornis/buildify/client/globals/enums.js';
import { DigitaleHeldenFont } from '@adornis/digitale-helden-shared/client/theme/fonts';
import { DigitaleHeldenSizeBreakpoint } from '@adornis/digitale-helden-shared/db/enums.js';
import { fontReset } from '@adornis/fonts/font-resets.js';
import { XH3 } from '@adornis/fonts/fonts';
import { customElement } from 'lit/decorators.js';

@customElement('d-h3')
export class DH3 extends XH3 {
  override styles() {
    return [
      fontReset(DigitaleHeldenFont.REGULAR, 1, 400, 1.25, 32),
      {
        [`@media screen and (max-width: ${DigitaleHeldenSizeBreakpoint(Size.TABLET)}px)`]: {
          ...fontReset(DigitaleHeldenFont.REGULAR, 1, 400, 1.286, 28),
        },
        [`@media screen and (max-width: ${DigitaleHeldenSizeBreakpoint(Size.MOBILE)}px)`]: {
          ...fontReset(DigitaleHeldenFont.REGULAR, 1, 400, 1.333, 24),
        },
      },
    ] as Styles[];
  }
}
